<template>
    <v-container>
        <!--v-layout align-center justify-center-->
        <v-layout align-center justify-center>
            <v-loading class="loading" v-model="loading" v-if="loading">
    
                <v-progress-circular persistent
                :size="70"
                :width="7"
                color="primary"
                indeterminate
                ></v-progress-circular>
        
            </v-loading>
            <v-flex xs12 sm8 md4>
                <!--v-card class="elevation-12"-->
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-toolbar-title><a href="javascript:history.back()" class="voltar"><img class="imgVoltar" :src="imgVoltar"></a>Criar Resumo Diário</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <!--v-form ref="form" v-model="valid" lazy-validation-->
                        <v-form ref="form" v-model="valid" lazy-validation>

                            <v-flex xs12 sm12 md12>
                                <v-card-text style="padding:0 0 0 0; width:100%"> 
                                    <v-select
                                        :items="itemsAlunos"
                                        item-value="alunoSlug"
                                        item-text="alunoName"
                                        label="Aluno"
                                        return-object
                                        v-model="aluno"
                                    ></v-select>
                                </v-card-text>
                            </v-flex><br />

                            <v-layout row wrap>
                                <v-flex xs11 sm5>
                                    <v-menu
                                    lazy
                                    :close-on-content-click="false"
                                    v-model="menu"
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    :nudge-right="40"
                                    max-width="290px"
                                    min-width="290px"
                                    >
                                    <v-text-field
                                        slot="activator"
                                        label="Data"
                                        v-model="date"
                                        prepend-icon="event"
                                        readonly
                                    ></v-text-field>
                                    <v-date-picker v-model="date" no-title scrollable actions>
                                        <!-- <template scope="{ save, cancel }"> -->
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <!-- <v-btn flat color="primary" @click="cancel">Cancel</v-btn> -->
                                            <v-btn flat color="primary" @click="save">OK</v-btn>
                                        </v-card-actions>
                                        <!-- </template> -->
                                    </v-date-picker>
                                    </v-menu>
                                </v-flex>
                            </v-layout>

                            <v-flex xs6 sm6 md6 style="float:left; padding-right:6px">
                                <v-text-field name="entrada" placeholder="00:00" v-mask="'##:##'" label="Entrada" type="text"
                                                v-model="entrada">
                                </v-text-field><br />
                            </v-flex>
                            <v-flex xs6 sm6 md6 style="float:right; padding-left:6px">
                                <v-text-field name="saida" placeholder="00:00" v-mask="'##:##'" label="Saída" type="text"
                                                v-model="saida">
                                </v-text-field><br />
                            </v-flex>

                            <label class="v-label theme--light">Como estou hoje:</label>
                            <template>
                                <v-layout>
                                    <v-flex xs12 sm6 offset-sm3>
                                    
                                        <v-container grid-list-sm fluid>
                                        <v-layout row wrap layout fill-height align-center justify-center ma-0 custom-rating>
                                            <v-flex xs2>
                                                <label class="label-rating">Ótimo</label>
                                                <a class="layout row wrap layout fill-height align-center justify-center ma-0" @click="emogiRate('1')">
                                                    <img :src="img1" />
                                                </a>
                                                    
                                            </v-flex>
                                            <v-flex xs2>
                                                <label class="label-rating">Bem</label>
                                                <a class="layout row wrap layout fill-height align-center justify-center ma-0" @click="emogiRate('2')">
                                                    <img :src="img2" />
                                                </a>
                                                    
                                            </v-flex>
                                            <!-- <v-flex xs2>
                                                <label class="label-rating">Normal</label>
                                                <a class="layout row wrap layout fill-height align-center justify-center ma-0 selected" @click="emogiRate('3')">
                                                    <img :src="img3" />
                                                </a>
                                                    
                                            </v-flex> -->
                                            <v-flex xs2>
                                                <label class="label-rating">Ruim</label>
                                                <a class="layout row wrap layout fill-height align-center justify-center ma-0" @click="emogiRate('4')">
                                                    <img :src="img4" />
                                                </a>
                                                    
                                            </v-flex>
                                            <v-flex xs2>
                                                <label class="label-rating">Doente</label>
                                                <a class="layout row wrap layout fill-height align-center justify-center ma-0" @click="emogiRate('5')">
                                                    <img :src="img5" />
                                                </a>
                                                    
                                            </v-flex>
                                        </v-layout>
                                        </v-container>
                                    
                                    </v-flex>
                                </v-layout>
                            </template><br />











                                   
                            <v-text-field name="horasSono" placeholder="00:00" v-mask="'##:##'" label="Horas de sono" type="text"
                                            v-model="horasSono">
                            </v-text-field>
                            

                            <v-flex xs12 sm12 md12>
                                <v-card-text style="padding:0 0 0 0; width:100%"> 
                                    <v-select
                                        :items="itemsCafeManha"
                                        item-value="value.cafeManhaID"
                                        item-text="value.cafeManhaName"
                                        label="Café da manha"
                                        return-object
                                        v-model="cafeManha"
                                    ></v-select>
                                </v-card-text>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                                <v-card-text style="padding:0 0 0 0; width:100%"> 
                                    <v-select
                                        :items="itemsAlmoco"
                                        item-value="value.almocoID"
                                        item-text="value.almocoName"
                                        label="Almoço"
                                        return-object
                                        v-model="almoco"
                                    ></v-select>
                                </v-card-text>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                                <v-card-text style="padding:0 0 0 0; width:100%"> 
                                    <v-select
                                        :items="itemsCafeTarde"
                                        item-value="value.cafeTardeID"
                                        item-text="value.cafeTardeName"
                                        label="Café da tarde"
                                        return-object
                                        v-model="cafeTarde"
                                    ></v-select>
                                </v-card-text>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                                <v-card-text style="padding:0 0 0 0; width:100%"> 
                                    <v-select
                                        :items="itemsJanta"
                                        item-value="value.jantaID"
                                        item-text="value.jantaName"
                                        label="Jantar"
                                        return-object
                                        v-model="janta"
                                    ></v-select>
                                </v-card-text>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                                <v-card-text style="padding:0 0 0 0; width:100%"> 
                                    <v-select
                                        :items="itemsEvacuacao"
                                        item-value="value.evacuacaoID"
                                        item-text="value.evacuacaoName"
                                        label="Evacuação"
                                        return-object
                                        v-model="evacuacao"
                                    ></v-select>
                                </v-card-text>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                                <v-card-text style="padding:0 0 0 0; width:100%"> 
                                    <v-select
                                        :items="itemsFrauda"
                                        item-value="value.fraudaID"
                                        item-text="value.fraudaName"
                                        label="Fraudas"
                                        return-object
                                        v-model="frauda"
                                    ></v-select>
                                </v-card-text>
                            </v-flex>

                            <v-flex xs6 sm6 md6 style="float:left; padding-right:6px">
                                <v-layout row wrap>
                                    <v-flex xs11 sm5>
                                        <v-switch
                                            v-model="banho"
                                            :label="`Banho:`"
                                        ></v-switch>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6 style="float:right; padding-left:6px">
                                <v-layout row wrap>
                                    <v-flex xs12 sm12>
                                        <v-switch
                                            v-model="licaoCasa"
                                            :label="`Lição de casa:`"
                                        ></v-switch>
                                    </v-flex>
                                </v-layout>
                            </v-flex>

                            <div style="clear:both">
                                <v-text-field name="observacao" label="Observação" type="text"
                                                v-model="observacao">
                                </v-text-field><br />
                            </div>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <!--v-btn color="primary" :disabled="!valid" @click="submit" data-cy="joinSubmitBtn">Cadastrar</v-btn-->
                        <v-btn color="primary" :disabled="!valid || !statusUpload" @click="criarResumoDiario" data-cy="joinSubmitBtn">Criar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="dialog" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">{{tituloModal}}</v-card-title>
                <!--v-card-text>Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.</v-card-text-->
                <v-card-actions>
                <v-spacer></v-spacer>
                <!--v-btn color="green darken-1" flat @click="dialog = false">Disagree</v-btn-->
                <v-btn color="green darken-1" flat @click="closeModal">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import db from './firebaseInit';
import firebase,{ storage } from 'firebase';

import {mask} from 'vue-the-mask'

import { userProperties, usersData } from '@/global.js'

import axios from 'axios'
import VueAxios from 'vue-axios'

import img1 from '../assets/muito-feliz.png';
import img2 from '../assets/feliz.png';
import img3 from '../assets/normal.png';
import img4 from '../assets/ruim.png';
import img5 from '../assets/muito-ruim.png';

import imgVoltar from '../assets/ic-voltar.png';

//Vue.use(VueAxios, axios)

export default {
    name: 'Criar-Diario',
    directives: {mask},
    
    data: vm => ({
        imgVoltar: imgVoltar,
        img1: img1,
        img2: img2,
        img3: img3,
        img4: img4,
        img5: img5,
        valid: false,
        observacao: null,
        timestamp: null,
        dialog: false,
        loading: false,
        slug: null,
        extensao : null,
        statusUpload: true,
        tituloModal: "Resumo Diário criado com sucesso!",
        date: new Date().toISOString().substr(0, 10),
        dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
        licaoCasa: false,
        pushIDs: null,
        banho: false,
        textoPush: null,
        entrada: null,
        saida: null,
        horasSono: null,
        rating: 3,
        menu: false,
        evacuacao: {
                value: {
                    evacuacaoID: 0,
                    evacuacaoName: 'Nenhuma vez'
                }
            },
        itemsEvacuacao: [
            {
                value: {
                    evacuacaoID: 0,
                    evacuacaoName: 'Nenhuma vez' // Aparece na timeline e na listagem
                },
                text: 'Nenhuma vezv'
            },
            {
                value: {
                    evacuacaoID: 1,
                    evacuacaoName: 'Um vez' // Aparece na timeline e na listagem
                },
                text: 'Um vez'
            },
            {
                value: {
                    evacuacaoID: 2,
                    evacuacaoName: 'Duas vezes' // Aparece na timeline e na listagem
                },
                text: 'Duas vezes'
            },
            {
                value: {
                    evacuacaoID: 3,
                    evacuacaoName: 'Três vezes' // Aparece na timeline e na listagem
                },
                text: 'Três vezes'
            }
            ,
            {
                value: {
                    evacuacaoID: 4,
                    evacuacaoName: 'Mais de 3 vezes' // Aparece na timeline e na listagem
                },
                text: 'Mais de 3 vezes'
            }
        ],
        frauda: {
                value: {
                    fraudaID: 0,
                    fraudaName: 'Nenhuma vez'
                }
            },
        itemsFrauda: [
            {
                value: {
                    fraudaID: 0,
                    fraudaName: 'Nenhuma vez'
                },
                text: 'Nenhuma vezv'
            },
            {
                value: {
                    fraudaID: 1,
                    fraudaName: 'Um vez' // Aparece na timeline e na listagem
                },
                text: 'Um vez'
            },
            {
                value: {
                    fraudaID: 2,
                    fraudaName: 'Duas vezes' // Aparece na timeline e na listagem
                },
                text: 'Duas vezes'
            },
            {
                value: {
                    fraudaID: 3,
                    fraudaName: 'Três vezes' // Aparece na timeline e na listagem
                },
                text: 'Três vezes'
            },
            {
                value: {
                    fraudaID: 4,
                    fraudaName: 'Quatro vezes' // Aparece na timeline e na listagem
                },
                text: 'Quatro vezes'
            },
            {
                value: {
                    fraudaID: 5,
                    fraudaName: 'Cinco vezes' // Aparece na timeline e na listagem
                },
                text: 'Cinco vezes'
            },
            {
                value: {
                    fraudaID: 6,
                    fraudaName: 'Seis vezes' // Aparece na timeline e na listagem
                },
                text: 'Seis vezes'
            },
            {
                value: {
                    fraudaID: 7,
                    fraudaName: 'Sete vezes' // Aparece na timeline e na listagem
                },
                text: 'Sete vezes'
            },
            {
                value: {
                    fraudaID: 8,
                    fraudaName: 'Oito vezes' // Aparece na timeline e na listagem
                },
                text: 'Oito vezes'
            },
            {
                value: {
                    fraudaID: 9,
                    fraudaName: 'Nove vezes' // Aparece na timeline e na listagem
                },
                text: 'Nove vezes'
            },
            {
                value: {
                    fraudaID: 10,
                    fraudaName: 'Dez vezes' // Aparece na timeline e na listagem
                },
                text: 'Dez vezes'
            },
            {
                value: {
                    fraudaID: 11,
                    fraudaName: 'Mais de 10 vezes' // Aparece na timeline e na listagem
                },
                text: 'Mais de 10 vezes'
            }
        ],
        cafeManha: {
            value: {
                cafeManhaID: 0,
                cafeManhaName: 'Não'
            }
        },
        itemsCafeManha: [
            {
                value: {
                    cafeManhaID: 0,
                    cafeManhaName: 'Não' // Aparece na timeline e na listagem
                },
                text: 'Não'
            },
            {
                value: {
                    cafeManhaID: 1,
                    cafeManhaName: 'Sim' // Aparece na timeline e na listagem
                },
                text: 'Sim'
            }
        ],
        almoco: {
            value: {
                almocoID: 0,
                almocoName: 'Não'
            }
        },
        itemsAlmoco: [
            {
                value: {
                    almocoID: 0,
                    almocoName: 'Não'
                },
                text: 'Não'
            },
            {
                value: {
                    almocoID: 1,
                    almocoName: 'Sim'
                },
                text: 'Sim'
            }
        ],
        cafeTarde: {
            value: {
                cafeTardeID: 0,
                cafeTardeName: 'Não'
            }
        },
        itemsCafeTarde: [
            {
                value: {
                    cafeTardeID: 0,
                    cafeTardeName: 'Não' 
                },
                text: 'Não'
            },
            {
                value: {
                    cafeTardeID: 1,
                    cafeTardeName: 'Sim'
                },
                text: 'Sim'
            }
        ],
        janta: {
            value: {
                jantaID: 0,
                jantaName: 'Não'
            }
        },
        itemsJanta: [
            {
                value: {
                    jantaID: 0,
                    jantaName: 'Não' 
                },
                text: 'Não'
            },
            {
                value: {
                    jantaID: 1,
                    jantaName: 'Sim'
                },
                text: 'Sim'
            }
        ],
        aluno: {
                // alunoSlug: 1,
                // alunoName: 'Alice'
        },
        itemsAlunos: [
            // {
            //         alunoSlug: 0,
            //         alunoName: 'Laura'
            // },
            // {
            //         alunoSlug: 1,
            //         alunoName: 'Alice'
            // }
        ],
        alunoSlug: null
    }),
    methods: { // ####################### Criar parte que criar documentos collections de cada escola ao realizar primeiro login do usuario Escola
        formatDate (date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${month}/${day}/${year}`
        },
        parseDate (date) {
            if (!date) return null

            const [month, day, year] = date.split('/')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },
        save() {
            this.menu = false;
        },
        criarResumoDiario(){

            // Log do sistema
            if(userProperties.escolaID != null){            
                // timestamp
                var now = new Date();
                var year = "" + now.getFullYear();
                var month = "" + (now.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
                var day = "" + now.getDate(); if (day.length == 1) { day = "0" + day; }
                var hour = "" + now.getHours(); if (hour.length == 1) { hour = "0" + hour; }
                var minute = "" + now.getMinutes(); if (minute.length == 1) { minute = "0" + minute; }
                var second = "" + now.getSeconds(); if (second.length == 1) { second = "0" + second; }
                //return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
                var customtimestamp = year + month + day + hour + minute + second

                db.collection('log_' + userProperties.escolaID).add({
                        escolaID: userProperties.escolaID,
                        slugAutor: userProperties.slug,
                        perfil: userProperties.perfil,
                        
                        //slug: this.slug,
                        customtimestamp: customtimestamp,
                        dia: day,
                        mes: month,
                        ano: year,
                        acao: "criar",
                        categoria: "diario",
                        pontos: 5
                        
                    })
                    .then(docRef => {
                        console.log('Document written with ID: ', docRef.id);

                        
                    })
                    .catch(function (error) {
                        console.log('Error adding document: ', error);
                        console.log("Erro no envio dos dados. Tente novamente mais tarde!")
                    })
            }
            else{
                alert("Sua sessão expirou, você será redirecionado para reautenticar!");
                this.$router.push(`/`);
            }

            if(userProperties.escolaID != null){
                this.loading = true
                // timestamp
                var now = new Date();
                var year = "" + now.getFullYear();
                var month = "" + (now.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
                var day = "" + now.getDate(); if (day.length == 1) { day = "0" + day; }
                var hour = "" + now.getHours(); if (hour.length == 1) { hour = "0" + hour; }
                var minute = "" + now.getMinutes(); if (minute.length == 1) { minute = "0" + minute; }
                var second = "" + now.getSeconds(); if (second.length == 1) { second = "0" + second; }
                //return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
                var customtimestamp = year + month + day + hour + minute + second

                db.collection('resumodiario_'+userProperties.escolaID).add({
                        escolaID: userProperties.escolaID,
                        slugAutor: userProperties.slug,
                        
                        slug: this.slug,
                        customtimestamp: customtimestamp,

                        date: this.date,
                        ano: this.date.substring(0,4),
                        mes: this.date.substring(5,7),
                        dia: this.date.substring(8,10),
                        entrada: this.entrada,
                        saida: this.saida,
                        horasSono: this.horasSono,
                        evacuacaoName: this.evacuacao.value.evacuacaoName,
                        evacuacaoID: this.evacuacao.value.evacuacaoID,
                        cafeManhaName: this.cafeManha.value.cafeManhaName,
                        cafeManhaID: this.cafeManha.value.cafeManhaID,
                        almocoName: this.almoco.value.almocoName,
                        almocoID: this.almoco.value.almocoID,
                        cafeTardeName: this.cafeTarde.value.cafeTardeName,
                        cafeTardeID: this.cafeTarde.value.cafeTardeID,
                        jantaName: this.janta.value.jantaName,
                        jantaID: this.janta.value.jantaID,
                        licaoCasa: this.licaoCasa,
                        banho: this.banho,
                        rating: this.rating,
                        aluno: this.aluno,
                        observacao: this.observacao

                        
                    })
                    .then(docRef => {

                        // //if(this.push == true){
                        //     console.log("entrou no if de enviar push");
                        //     var postData = {
                        //         "notification": {        
                        //             "title": "Comunicado",
                        //             "body": this.texto,
                        //             //"click_action": "http://localhost:3000/",
                        //             "icon": "https://static.thenounproject.com/png/447685-200.png"    
                        //         },    
                        //         //"to": "egWUxBfoF_M:APA91bFI3XEPVD6dFP9W2_G__J9DzbTb9qpmFBW0NGRhcBTVxdNM_j_VOKo5V79Ro1-jmZLXYv6Wzq39ELzMUW-TTHAS7Nb6FSt762n_8E7SCwtHfFwn-QRClj3SD5mH2iO5sijMHY0a"
                        //         "to": this.pushIDs
                        //     }

                        //     let axiosConfig = {
                        //         headers: {
                        //             'Content-Type': 'application/json',
                        //             "Authorization": "key=AAAAiOjxl8Q:APA91bHly_RtJvUwP5kzHiHbulyRMI7oChExHjzyf1MFimlObjrX_-kRxCMWW77a2hBBxU7Oz-BhnFBANbCBHMObkiKAMHZSgxfw47LKjwGTRs6DCjtDkvvyRLiJcCMBHHh4uS93E0ha",
                        //         }
                        //     };

                        //     axios.post('https://fcm.googleapis.com/fcm/send', postData, axiosConfig)
                        //     .then((res) => {
                        //         console.log("PUSH ENVIADO. RESPONSE RECEIVED: ", res);
                        //     })
                        //     .catch((err) => {
                        //         console.log("ERRO AO ENVIAR PUSH. AXIOS ERROR: ", err);
                        //         alert("Erro no envio de push.")
                        //     })
                        // //}

                        

                        console.log('Document written with ID: ', docRef.id);
                        //this.$router.push(`/${slug}/success`)
                        this.loading = false
                        this.dialog = true
                        
                    })
                    .catch(function (error) {
                        this.loading = false
                        console.log('Error adding document: ', error);
                        console.log("Erro no envio dos dados. Tente novamente mais tarde!")
                    })
            }
            else{
                alert("Sua sessão expirou, você será redirecionado para reautenticar!");
                this.$router.push(`/`);
            }
            
        },
        closeModal(){
            this.$router.push(`/resumo-diario-listagem`);
        },        
        submit() {
            if (this.$refs.form.validate() && this.statusUpload == true) {
            }
            if (this.$refs.form.validate() && this.statusUpload == false) {
                alert("Por favor, faça o upload da foto do perfil do usuário")
            } 
        },
        generateUUID () {
          let d = new Date().getTime()
          let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            let r = (d + Math.random() * 16) % 16 | 0
            d = Math.floor(d / 16)
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
          })
          return uuid
        },
        emogiRate(item){
            this.rating = item
        }
        
    },
    mounted() {
        const slug = this.generateUUID()
        this.slug = slug;
        var that = this;

        // se perfil não for escola ou administrador
        if(userProperties.perfil == 1 || userProperties.perfil == 2 || userProperties.perfil == 3 || userProperties.perfil == 6 || userProperties.perfil == 7){
            alert("Acesso negado!");
            this.$router.push(`/?redirect=`+window.location.pathname)
        }

        // Lista de alunos
        this.itemsAlunos = []
        this.loading = true
        
        db.collection("usuarios")
        .where("escolaID", "==", userProperties.escolaID).where("perfil", "==", 7)
        .get()
        .then((querySnapshot) => {
            querySnapshot.forEach(doc => {
                
                // doc.data() is never undefined for query doc snapshots
                //console.log(doc.id, " => ", doc.data());                    
                let customObj = doc.data()
                
                    // ######## IF por alunos que pertencem a turma do professor logado
                    usersData.slugUsuariosPorTurma.forEach((item, index) => {
                        if(item == customObj.slug){
                            this.itemsAlunos.push({"alunoName": customObj.nome, "alunoSlug": customObj.slug});
                        }
                    });
                    
                    this.alunoSlug = customObj.slug;
                    this.loading = false

                 
                
            });
        });
        //console.log(this.itemsAlunos);
        

        $(".custom-rating a").click(function(){
            $(".custom-rating a").removeClass("selected");
            $(this).addClass("selected");
        })
    }
};
</script>

<style scoped>
    .loading{
        position: absolute;
        top:20%;
        left:48%;
        z-index: 2;
    }

    .btCirculo{
        height: 30px;
        width: 30px;
    }

    .btCirculo a{
        color:#fff;
    }

    progress{
        width:100%;
        margin-top: 6px;
    }

    label.v-label.theme--light{
        margin-bottom: 6px;
        display: block
    }

    .adicionarItem.btCirculo{
        position: relative;
        top: 12px;
        left: 5px;
    }

    .excluirItem.btCirculo{
        position: relative;
        left: 5px;
        top:-10px;
    }

    .box-items-selecionados{
        background: silver;
        width: 100%;
        padding: 20px 5px 5px 10px;
    }

    .container{
        padding: 0 0 !important;
    }

    .grid-list-sm img{
        width: 70%;
        height: auto !important;
    }

    .grid-list-sm a{
        min-height: 70px;
    }

    a.selected img{
        width: 100%;
        height: auto !important;
        cursor: pointer;
    }

    .label-rating{
        display: block;
        text-align: center
    }

    .buttonOk{
        position: absolute;
        right: 2px;
        bottom: 5px;
    }
    
</style>
